export interface IStudioFilterResultRequests<T> {
  totalPages: number;
  totalAssets: number;
  assetsPerPage: number;
  currentPage: number;
  isLastPage: boolean;
  assets: T[];
}

export interface IStudios {
  id: string;
  studioName: string;
}

export interface IStudiosApi {
  _id: string;
  studioName: string;
}

export default class Studios implements IStudios {
  public readonly id: string;

  public readonly studioName: string;

  constructor(id: string, studioName: string) {
    this.id = id;
    this.studioName = studioName;
  }

  static fromApiModel(apiModel: IStudiosApi) {
    const { _id, studioName } = apiModel;

    return new Studios(_id, studioName);
  }

  static arrayFromApiModel(arrayApiModel: IStudiosApi[]) {
    const array = arrayApiModel.map(apiModel => this.fromApiModel(apiModel));

    return array;
  }

  static arrayPaginatedFromApiModel(
    arrayApiModel: IStudioFilterResultRequests<IStudiosApi>,
  ) {
    const array = this.arrayFromApiModel(arrayApiModel.assets);

    return {
      ...arrayApiModel,
      assets: array,
    };
  }
}
